

import React from "react";

const HoverCircles = () => {
  const containerStyle = {
    display: "flex",
    flexWrap: "wrap", // Allow wrapping of items to the next line
    justifyContent: "center",
    alignItems: "center",
    padding: "0 15px",
    gap: "20px",
    margin: "0 auto",
    width: "100%",
  };

  const circleStyle = {
    position: "relative",
    width: "100%",
    maxWidth: "280px", // Set a maximum width for each circle
    height: "280px",
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    color: "#000",
    fontSize: "14px",
    fontWeight: "bold",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #000",
     boxShadow: "20px 20px 40px rgba(0, 0, 0, 0.2)",
    transition: "background-color 0.3s ease, color 0.3s ease, border 0.3s ease",
    cursor: "pointer",
    boxSizing: "border-box",
  };

  const hoverStyle = {
    backgroundColor: "#000",
    color: "#FFFFFF",
    border: "2px solid blue",
  };

  const titleContainerStyle = {
    textAlign: "center",
    marginBottom: "20px",
    fontSize: "30px",
    fontWeight: "bold",
    color: "#FFA500",
  };

  const circles = [
    {
      title: " Basics of Tool and Fixture Design",
      description:
        "Understand how to design tools and fixtures that are crucial for manufacturing processes like machining, assembly, and testing.",
    },
    {
      title: "Practical Learning",
      description:
        "Gain hands-on experience with design software like AutoCAD and SolidWorks to create basic tools and fixtures.",
    },
    {
      title: "Improve Efficiency",
      description:
        "Learn how well-designed tools and fixtures can help streamline production processes and reduce errors.",
    },
    {
      title: "	Cost-Effective Design",
      description:
        "Discover how simulation tools allow you to test your designs without building physical prototypes, saving time and money.",
    },
  ];

  return (
    <div>
      <div style={titleContainerStyle}>
        <span style={{ color: "#000", fontFamily: "roboto" }}>WHY YOU SHOULD</span>{" "}
        <span style={{ color: "#FFA500", fontFamily: "roboto" }}>ATTEND</span>
      </div>

      <div style={containerStyle}>
        {circles.map((circle, index) => (
          <div
            key={index}
            style={circleStyle}
            onMouseEnter={(e) => Object.assign(e.currentTarget.style, hoverStyle)}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = circleStyle.backgroundColor;
              e.currentTarget.style.color = "#000";
              e.currentTarget.style.border = circleStyle.border;
            }}
          >
            <h3
              style={{
                margin: "10px 0",
                fontSize: "20px",
                color: "orange",
                fontFamily: "roboto",
              }}
            >
              {circle.title}
            </h3>
            <p
              style={{
                fontSize: "14px",
                padding: "10px",
                margin: "0",
                textAlign: "center",
              }}
              dangerouslySetInnerHTML={{ __html: circle.description }}
            />
          </div>
        ))}
      </div>

      <style jsx>{`
        @media (max-width: 1200px) {
          h3 {
            font-size: 18px;
          }

          p {
            font-size: 12px;
          }
        }

        @media (max-width: 768px) {
          .container {
            flex-direction: column;
          }

          .circle {
            max-width: 90%; // Adjust the width for mobile
            height: 240px;
          }

          .title {
            font-size: 24px;
          }
        }

        @media (max-width: 480px) {
          h3 {
            font-size: 16px;
          }

          p {
            font-size: 12px;
          }

          .circle {
            height: 220px;
          }
        }
      `}</style>
    </div>
  );
};

export default HoverCircles;



